import { render, staticRenderFns } from "./TelegramBotCard.vue?vue&type=template&id=ab0b1486&scoped=true"
import script from "./TelegramBotCard.vue?vue&type=script&lang=js"
export * from "./TelegramBotCard.vue?vue&type=script&lang=js"
import style0 from "./TelegramBotCard.vue?vue&type=style&index=0&id=ab0b1486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0b1486",
  null
  
)

export default component.exports